import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../components/header'
import Footer from '../../components/footer'
import Head from '../../components/head';
import Home from '../../components/publico/home'

function HomeScreen() {
        return (
            <Fragment>
                <Head titulo="Monte sua configuração | Departamento de TI" />
                <HeaderLogged />
                <Container>
                   <Home />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default HomeScreen;